import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {Game} from "../Game";
import {SymbolContainer} from "../reels/SymbolContainer";
import {GameFeatureMode, SYMBOL} from "../enums/Enum";
import {GameUtils} from "../utils/GameUtils";
import {Symbol} from "../reels/Symbol";
import {Config} from "../config/Config";
import {NudgeSymbol} from "../reels/NudgeSymbol";
import {Sound} from "../sound/Sound";

export class SplitRunner implements SimplePresentationRunner {
    private _xSplitCount: number = 0;
    private _triggeredFeatureIndex: number = 0;
    private _mainTl: gsap.core.Timeline;

    shouldRun(): boolean { //splits triggered from Enhancers
        return Game.model.enhancerFeatures.indexOf(SYMBOL.X_SPLIT) > -1;
    }

    start(flowStateController: SimplePresentationRunnerController): void {
        this._xSplitCount = 0;
        this._triggeredFeatureIndex = 0;
        this.playAllEnhancerXSplits(flowStateController);
    }

    public playSplit(splitOriginReelId: number, rowId: number, subRowId: number): gsap.core.Timeline {
        const featureTl: gsap.core.Timeline = new gsap.core.Timeline();
        const symInReel: number[] = GameUtils.getReelSizeWithEnhancer(Game.model.fireFrameCount >= 4, Game.model.fireFrameCount >= 8, Game.model.fireFrameCount >= 6);
        this._xSplitCount++;
        const splitTriggeredSymbolContainer: SymbolContainer = GameUtils.getSymbol(splitOriginReelId, rowId);
        featureTl.add(() => {
            subRowId = splitTriggeredSymbolContainer.getLatestSplitIndex();
            const splitSymbol: Symbol = splitTriggeredSymbolContainer.symbols[subRowId];
            const animNameArr: string[] = (splitSymbol.state.tracks[0].animation.name).split("_");
            const animName: string = animNameArr[animNameArr.length - 1];
            splitSymbol.state.setAnimation(0, animName + "_without_logo", false);
        }, 0);
        for (let reelId: number = 0; reelId < 5; reelId++) {

            let lastRowId: number = symInReel[reelId] - 1;
            const symbolContainer: SymbolContainer = GameUtils.getSymbol(reelId, lastRowId);
            if(symbolContainer.symbolName == SYMBOL.X_MENTAL || symbolContainer.symbolName == SYMBOL.S1){ //#432
                continue;
            }
            Game.foregroundElements.waysCounter.symCountInReels[reelId]++;
            const isXHoleSym: boolean = symbolContainer.symbolName === SYMBOL.X_HOLE;
            const pos: PIXI.Point = GameUtils.getSymbolPos(reelId, lastRowId);
            if (symbolContainer.isTopHalf) {
                pos.y = pos.y - 49;
            }
            pos.y -= symbolContainer.pivot.y;
            //const animName: string = currSymbol.currentHeight < 90 ? "50_cut_effect" : (currSymbol.currentHeight < 100) ? "99_cut_effect" : "198_cut_effect";
            let animName: string = this._xSplitCount > 2 ? "50_cut_effect" : (this._xSplitCount === 2) ? "99_cut_effect" : "198_cut_effect";
            const speed: number = 2.2;//this._xSplitCount > 2 ? 2.8 : (this._xSplitCount === 2) ? 2.6 : 2.2;
            const splitEffects: PIXI.spine.Spine = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("xSplitEffects"));
            const xFeatureOverlaySpine: PIXI.spine.Spine = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("xSplitWinOverlay"));
            const xSpitBloodDripSpine: PIXI.spine.Spine = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("xSpitBloodDripEffects"));


            Game.effectsView.addChild(splitEffects);
            if (isXHoleSym) {
                animName = Game.model.isXHoleActive() ? "198_cut_effect_suck" : "198_cut_effect_suck_noWin";
                xFeatureOverlaySpine.visible = false;
                xSpitBloodDripSpine.visible = false;
            }
            const xSplitAnim = GameUtils.createTimelineForAnimation(splitEffects, 0, animName, false).timeScale(speed);
            if (reelId === 0) {
                xSplitAnim.add(() => {
                    Game.soundPlayer.playSound(Sound.X_SPLIT_START);
                    Game.soundPlayer.playSound(Sound.X_SPLIT_SPLITTING);
                }, 0);
                xSplitAnim.add(() => {
                    Game.soundPlayer.stopSound(Sound.X_SPLIT_SPLITTING);
                    Game.soundPlayer.playSound(Sound.X_SPLIT_END);
                });
            }
            featureTl.add(xSplitAnim, 0);
            featureTl.add(() => {
                // if (reelId === 0) {
                //     Game.soundPlayer.playSound(Sound.X_SPLIT_START);
                //     Game.soundPlayer.playSound(Sound.X_SPLIT_SPLITTING);
                // }
                const symIndex: number = Math.min(subRowId, symbolContainer.symbols.length - 1);
                const symAtSubRowId: Symbol = symbolContainer.symbols[symIndex];
                if (reelId === splitOriginReelId) {
                    symAtSubRowId.symbolName = SYMBOL.WILD;
                }

                const symHeight: number = Config.SYMBOL_HEIGHT / (symbolContainer.symbols.length + 1);
                const y: number = (symHeight * (symIndex + 1)) - 99;
                if (Game.reelView.reelModels[reelId].isNudgeReel) {
                    let y: number = 460;
                    if (reelId === 2) {
                        y = 365;
                    }
                    xFeatureOverlaySpine.position.set(pos.x, y);
                    splitEffects.position.set(pos.x, y);
                    xSpitBloodDripSpine.position.set(pos.x, y);
                } else {
                    xFeatureOverlaySpine.position.set(pos.x, pos.y + symAtSubRowId.y);
                    splitEffects.position.set(pos.x, pos.y + symAtSubRowId.y);
                    xSpitBloodDripSpine.position.set(pos.x, (pos.y + y));
                }
                xFeatureOverlaySpine.height = symAtSubRowId.currentHeight * 1.62;
                xSpitBloodDripSpine.scale.y = (symHeight * 2) / 202;
            }, 0);

            featureTl.add([
                () => {
                    Game.effectsView.addChild(xSpitBloodDripSpine, xFeatureOverlaySpine);
                },
                GameUtils.createTimelineForAnimation(xFeatureOverlaySpine, 0, "198_win", false),
                GameUtils.createTimelineForAnimation(xSpitBloodDripSpine, 0, "198_win", false)
                //], 0.7);
            ], 0.8 - (speed - 1.64));

            featureTl.add(() => {
                // if (reelId === 0) {
                //     Game.soundPlayer.stopSound(Sound.X_SPLIT_SPLITTING);
                //     Game.soundPlayer.playSound(Sound.X_SPLIT_END);
                // }

                if (Game.reelView.reelModels[reelId].isNudgeReel) {
                    let nudgeSymRowId: number = reelId === 2 ? 3 : 2;
                    const symbolContainer: SymbolContainer = GameUtils.getSymbol(reelId, nudgeSymRowId);
                    (symbolContainer.symbols[0] as NudgeSymbol).updateMultiplier(1);
                } else {
                    if (Game.model.gameData.evaluatedArea[reelId][rowId] !== SYMBOL.X_HOLE && Game.model.gameData.evaluatedArea[reelId][rowId] !== SYMBOL.X_MENTAL) {
                        symbolContainer.splitByFeature(subRowId)
                        //Game.stickyView.checkAndSetStickyDeadMultiplierToSymbol(symbolContainer);
                    }
                }
                //}, 1);
            }, 1.2 - (speed - 1.64));
            featureTl.add(() => {
                splitEffects.parent.removeChild(splitEffects);
                xFeatureOverlaySpine.parent.removeChild(xFeatureOverlaySpine);
                xSpitBloodDripSpine.parent.removeChild(xSpitBloodDripSpine);
            });
        }
        featureTl.add(() => {
            Game.foregroundElements.waysCounter.updatePossibleWaysCounter();
        })
        return featureTl;
    }

    private playAllEnhancerXSplits(flowStateController: SimplePresentationRunnerController): void {
        this._mainTl = new gsap.core.Timeline();
        const splitRowArr: number[] = [];
        this._mainTl.add(() => {
            flowStateController.setSkipCallback(() => {
                this.onSkip();
            });
        });
        if (this._triggeredFeatureIndex >= Game.model.enhancerFeatures.length) {
            flowStateController.finish();
        } else {
            if (Game.model.enhancerFeatures[this._triggeredFeatureIndex] === SYMBOL.X_SPLIT) {
                if (this._triggeredFeatureIndex == 0 && Game.model.fireFrameCount >= 4) {
                    this._mainTl.add(this.playEnhancerSplits(1, 2));
                    this.addSplitRow(splitRowArr, 2);
                } else if (this._triggeredFeatureIndex == 1 && (Game.model.fireFrameCount >= 8)) {
                    this._mainTl.add(this.playEnhancerSplits(2, 3));
                    this.addSplitRow(splitRowArr, 3);
                } else if (this._triggeredFeatureIndex == 2 && Game.model.fireFrameCount >= 6) {
                    this._mainTl.add(this.playEnhancerSplits(3, 2));
                    this.addSplitRow(splitRowArr, 2);
                }
                this._triggeredFeatureIndex++;
                this._mainTl.add(() => {
                    const stickyTl: gsap.core.Timeline = new gsap.core.Timeline();
                    splitRowArr.forEach((rowId: number) => {
                        for (let reelId: number = 0; reelId < 5; reelId++) {
                            const lastRowId: number = Math.min(rowId, Config.SYMBOLS_IN_REEL[reelId] - 1); //row will be 3 for mid enhancer and 3 will not be available for other reel.
                            stickyTl.add(Game.stickyView.checkAndSetStickyDeadMultiplierToSymbol(GameUtils.getSymbol(reelId, lastRowId)), 0);
                        }
                    });
                    stickyTl.add(() => {
                        this.playAllEnhancerXSplits(flowStateController);
                    });

                });
            } else {
                this._triggeredFeatureIndex++;
                this.playAllEnhancerXSplits(flowStateController);
            }
        }
    }

    private addSplitRow(splitRowArr: number[], rowId: number) {
        if (Game.model.isStickyDeadApplicable()) {
            if (splitRowArr.indexOf(rowId) === -1) {
                splitRowArr.push(rowId);
            }
        }
    }

    private playEnhancerSplits(reelId: number, rowId: number): gsap.core.Timeline {
        const featureTl: gsap.core.Timeline = new gsap.core.Timeline();
        const symbolContainer: SymbolContainer = GameUtils.getSymbol(reelId, rowId);
        symbolContainer.symbols.forEach((sym: Symbol, index: number) => {
            if (sym.symbolName === SYMBOL.X_SPLIT) {
                featureTl.add(this.playSplit(reelId, rowId, index));
            }
        });
        return featureTl;
    }

    private onSkip() {
        this._mainTl.timeScale(20);
    }

}